import { AssessmentRecord, AssessmentRecordUserStatus } from '@scaleup/models';
import { DotsMenu, Tag, TagColor } from '../../ui';
import { snakeCaseToWords } from '../../utils';

interface IProps {
  assessment: AssessmentRecord;
  color: 'white' | 'green';
}

const STATUS_TO_COLOR: Record<AssessmentRecordUserStatus, TagColor> = {
  PENDING: 'red',
  INVITE_SENT: 'blue',
  COMPLETED: 'green',
};

export const AssessmentParticipants = ({ assessment, color }: IProps) => {
  if (!assessment.users) {
    return null;
  }

  return (
    <div
      className={`p-5 rounded-[1rem] ${color === 'white' ? 'bg-white' : 'bg-[#e9f2ee]'}  flex flex-col gap-2 mt-4`}
    >
      <div className="flex justify-between">
        <p className="font-bold text-text-primary">Participants:</p>
        <DotsMenu items={[]} />
      </div>
      <div className="flex flex-wrap gap-1">
        {(Object.keys(assessment.users) || []).map((it) => {
          const user = assessment.users![it]!;
          // TODO figure out participant status
          return (
            <Tag
              key={user.userId}
              color={STATUS_TO_COLOR[user.status]}
              text={
                <span>
                  <span className="text-text-secondary">{`${user.name}: `}</span>
                  {`${snakeCaseToWords(user.status)}`}
                </span>
              }
            />
          );
        })}
      </div>
    </div>
  );
};
